module.exports = __webpack_public_path__ + "media/bootstrap-icons/sort-numeric-down-65b6decb.svg";